/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import AdminProductSearch from "components/widgets/admin/AdminProductSearch";
import "components/elements/main/index.scss";
import { checkUserAllowed } from "helpers/utils.js";

const AdminMainProductSearch = (props) => {

  const [state] = useState({
    layoutColumns: 3,
  });

    const {
        userDetails
    } = props;

    useEffect(() => {
    props.adminResetSearchProducts();
    document.getElementById("color").setAttribute("href", "#");
  }, []);

    const renderProductSearch = () => {
        if (checkUserAllowed(userDetails.userlevel, "products")) {
            return <AdminProductSearch {...props} colSize={state.layoutColumns} />;
        } else {
            return  <div>Not available </div>;
        }
    }

    return (
        <div>
            {
                renderProductSearch()
            }
        </div>
    );
};

AdminMainProductSearch.propTypes = {
  adminResetSearchProducts: PropTypes.func.isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
};

// Mapping Props and State.
const AdminMainProductSearchComponent = connect(
  ({ adminProducts, bootupInfo }) => ({
    bootupInfo,
      userDetails: bootupInfo.userDetails,
    reqStatus: adminProducts.reqStatus,
    isLoading: adminProducts.isLoading,
    serviceError: adminProducts.serviceError,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(AdminMainProductSearch);

export { AdminMainProductSearchComponent as default };
